import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import GridViewIcon from '@mui/icons-material/GridView';
import HtmlIcon from '@mui/icons-material/Html';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ClosedCaptionOffIcon from '@mui/icons-material/ClosedCaptionOff';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

export default function VEElement(element, props={}) {
    let icon, title;

    switch (element.type) {
        case "image":
            icon = <PhotoCameraIcon {...props} />;
            title = element.comment ?? "Image";
            break;
        case "video":
            icon = <OndemandVideoIcon {...props} />;
            title = element.comment ?? "Video";
            break;
        case "audio":
            icon = <AudioFileIcon {...props} />;
            title = element.comment ?? "Audio";
            break;
        case "voice":
            icon = <ChatBubbleOutlineIcon {...props} />;
            title = element.comment ?? element.text ?? "Voice";
            break;
        case "text":
            icon = <TextFieldsIcon {...props} />;
            title = element.comment ?? element.text ?? "Text";
            break;
        case "component":
            icon = <GridViewIcon {...props} />;
            title = element.comment ?? element.component ?? "Component";
            break;
        case "html":
            icon = <HtmlIcon {...props} />;
            title = element.comment ?? "HTML";
            break;
        case "audiogram":
            icon = <GraphicEqIcon {...props} />;
            title = element.comment ?? "Audiogram";
            break;
        case "subtitles":
            icon = <ClosedCaptionOffIcon {...props} />;
            title = element.comment ?? "Subtitles";
            break;
        default:
            icon = <QuestionMarkIcon {...props} />;
            title = element.comment ?? "?";
            break;
    }
    return {
        icon: icon,
        title: title
    };
}

